<template>
    <b-modal :id="modalID" @shown="onShown" title="Choose period" class="modal-primary" @hidden="
        $emit('date-picker-modal-emit', selectedYear.getFullYear().toString())
        " @ok="
        $emit('date-picker-modal-emit', selectedYear.getFullYear().toString()),
        fetchData()
        ">
        <b-form>
            <b-form-group label="Year" label-for="changedYear" :label-cols="3">
                <datepicker use-utc format="yyyy" :bootstrap-styling="true" :minimum-view="'year'" v-model="selectedYear" name="changedYear"
                    :show-week-numbers="false" :calendar-button="false" :clear-button="false"></datepicker>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
    name: "YearModal",
    components: {
        Datepicker
    },
    props: {
        fetchData: Function,
        year: String,
        modalID: String
    },
    data: function () {
        return {
            selectedYear: this.year
        };
    },
    methods: {
        onShown() {
            this.selectedYear = this.year;
        }
    }
};
</script>

<style scoped></style>